import PublicLayout from "../../layouts/publicLayout";
import {
  Box,
  Avatar,
  TextField,
  Button,
  FormHelperText,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "./../../assets/images/newLogo.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ComponentBackdrop from "../../components/backdrop";
import { bannedDomains } from "../../data/bannedDomains";
import { passwordRules } from "../../data/passwordRules";

import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";
import ForgotPassword from "./forgotpassword";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";
import poisum from "./../../assets/images/poisum.png";

const VerifyEmail = () => {
  const [openLoading, setOpenLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    username: "",
    client_id: "poisum-mobile",
  });

  const [errors, setErrors] = useState({
    username: "",
  });

  const labelWidth = 170;

  const {
    apiUrls: { accountMgtApiUrl },
  } = useApiClient();

  const handleChange = (field, event) => {
    const value = event.target.value;

    setData({ ...data, [field]: value });
    if (field === "username") {
      const error = validateEmail(value);
      setErrors((data) => ({ ...data, username: error }));
    }
  };

  const validateEmail = (value) => {
    if (!value) return "Email is required.";

    // Basic email format validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address.";
    }

    // Check if email has a domain part
    const parts = value.split("@");
    if (parts.length !== 2) {
      return "Please enter a valid email address.";
    }

    const domain = parts[1];

    // Check if domain is in banned domains list
    // if (bannedDomains.includes(domain)) {
    //   return `Emails from ${domain} are not allowed. Use your work email address.`;
    // }

    return ""; // valid
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const newErrors = {
      username: validateEmail(data.username),
    };

    setErrors(newErrors);

    if (newErrors.username) {
      toast.error(newErrors.username);
      return;
    }

    try {
      setOpenLoading(true);

      const response = await api.post(
        `${accountMgtApiUrl}SourceUser/CheckFirstTime`,
        data
      );

      localStorage.setItem("email", data.username);

      if (response.status === 200) {
        console.log("success verify", response);

        const updatedApiUrl = response.data.data.tenant_mobile_api_url;
        // const updatedApiUrl = "http://192.168.3.209:7071/api/v2.5"; //for pro plan
        localStorage.setItem("mobileApiUrl", updatedApiUrl);
        localStorage.setItem("employeeId", response.data.data.linked_user_id);
        localStorage.setItem("isFirstTime", response.data.data.is_first_time);

        if (response.data.data.is_first_time) {
          // console.log("first time login");

          sessionStorage.setItem("tempPw", "poisum");

          const loginResponse = await api.post(
            `${accountMgtApiUrl}SourceUser/SourceUserLogin`,
            {
              username: localStorage.getItem("email"),
              password: "poisum",
              client_id: "poisum-mobile",
            }
          );

          if (loginResponse.status === 200) {
            localStorage.setItem("token", loginResponse.data.data.access_token);
            localStorage.setItem(
              "refreshToken",
              loginResponse.data.data.refresh_token
            );
            localStorage.setItem(
              "employeeId",
              loginResponse.data.data.user.linked_user_id
            );


            console.log(
              "loginResponse.data.data.user.is_first_time",
              loginResponse.data.data.user.is_first_time
            );

            setTimeout(() => {
              navigate("/resetpassword");
            }, 2000);
          }
        } else {
          // console.log("second time login");

          setTimeout(() => {
            navigate("/signin");
          }, 2000);
        }
      }
    } catch (error) {
      setOpenLoading(false);
      ErrorAlert(error, navigate);
    }
  };

  return (
    <PublicLayout>
      <ComponentBackdrop openBackdrop={openLoading} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            maxWidth: { xs: "100%", md: 1100 },
            overflowY: "auto",
            boxShadow: { xs: "none", md: "0px 4px 20px rgba(0, 0, 0, 0.1)" },
            backgroundColor: "background.main",
            borderRadius: { xs: "10px", md: "15px" },
            py: { xs: 2, sm: 8, md: 6 },
            px: { xs: 1, sm: 2, md: 12 },
            mx: { xs: 0, md: 2 },
            minHeight: { xs: "50vh", md: "auto" },
            height: { xs: "100%", sm: "90%", md: "650px" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-around",
              width: "100%",
              gap: { xs: 2, md: 4 },
            }}
          >
            {/* Logo Section */}
            <Box
              sx={{
                display: "flex",
                position: "relative",
                borderRadius: "15px",
                p: { xs: 1, sm: 2, md: 4 },
                width: "100%",
                maxWidth: { xs: 220, sm: 300, md: 400 },
                mx: "auto",
                height: { xs: 120, sm: 180, md: 250 },
                mb: { xs: 3, md: 0 },
              }}
            >
              {/* Faint Logo in Background */}
              <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: {
                    xs: 100,
                    sm: 160,
                    md: 200,
                    lg: 250,
                  },
                  height: "auto",
                  zIndex: 0,
                }}
              />
            </Box>

            <Box
              sx={{
                backgroundColor: "#39483f43",
                borderRadius: "15px",
                py: { xs: 2, sm: 3, md: 4 },
                px: { xs: 2, sm: 4, md: 6 },
                width: { xs: "100%", sm: "90%", md: "380px" },
                height: "auto",
                maxWidth: { xs: "100%", sm: "480px" },
              }}
            >
              {/* Title */}
              <Typography
                variant="title"
                display="block"
                fontWeight={600}
                gutterBottom
                textAlign="center"
                mb={3}
                textTransform={"uppercase"}
                sx={{ color: "#fff" }}
              >
                POISUM portal
              </Typography>

              <Typography
                variant="subtitle"
                display="block"
                fontWeight={600}
                gutterBottom
                mb={2}
                textTransform={'uppercase'}
                sx={{ color: "#fff" }}
              >
                Login
              </Typography>

              {/* Form */}
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                autoComplete="off"
              >
                <Stack spacing={2} width="100%">
                  {/* Email Field */}
                  <Box>
                    <Typography variant="body" sx={{ mb: 1, fontWeight: 500, color: "#fff" }}display="block">
                      Email
                    </Typography>
                    <TextField
                      placeholder="Enter your email address"
                      autoFocus
                      id="username"
                      name="email"
                      type="email"
                      value={data.username}
                      onChange={(e) => handleChange("username", e)}
                      error={!!errors.username}
                      helperText={errors.username}
                      slotProps={{
                        input: { autoComplete: "on" },
                      }}
                      size="normal"
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: 3,
                        },
                      }}
                    />
                  </Box>

                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    size="large"
                    sx={{
                      fontSize: "14px",
                      backgroundColor: "primary.main",
                      borderRadius: "12px",
                      paddingY: "12px",
                      fontWeight: "500",
                      textTransform: "capitalize"
                    }}
                  >
                    Next
                  </Button>
                </Stack>

                {/* Error Message */}
                {errors.form && (
                  <FormHelperText
                    sx={{
                      color: "error.main",
                      textAlign: "center",
                      mt: 2,
                    }}
                  >
                    {errors.form}
                  </FormHelperText>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          component="img"
          src={poisum}
          alt="poisum"
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: 1000 },
            mt: { xs: -1.5, sm: -3.5, md: -6 }, // keep slight overlap
            mx: "auto",
            display: "block",
            opacity: 0.9, // optional like your screenshot
          }}
        />
    </PublicLayout>
  );
};

export default VerifyEmail;
